import { createFileRoute } from '@tanstack/react-router';

import {
  loadReconciliationMessages,
  loadReconciliationScreens,
  reconciliationScreen,
  reconciliationSearch,
} from '@/modules/reconciliation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// `/concilicao` (grafia do legado, router.tsx:779): o `legacyPath` do menu (S28), abas por `?tab=` (S29).
export const Route = createFileRoute('/_app/concilicao/')({
  validateSearch: reconciliationSearch,
  staticData: { screen: reconciliationScreen },
  loader: () => loadReconciliationMessages(),
  component: lazyScreen(loadReconciliationScreens, 'ReconciliationPage'),
});
